export const cleanCategoryName = (name) => {
  if (!name) return 'Unknown';
  let upper = name.toUpperCase();
  if (upper === 'REPAIR, MAINTENANCE, AND INSTALLATION OF PLANT/') return 'Repair, maintenance, and installation of plant/machinery';
  if (upper === 'MANPOWER OUTSOURCING SERVICES - MINIMUM WAGE - SKI') return 'Manpower outsourcing services - minimum wage - skilled';
  if (upper === 'MANPOWER OUTSOURCING SERVICES - MINIMUM WAGE -') return 'Manpower outsourcing services - minimum wage - unskilled';
  
  let n = name.charAt(0).toUpperCase() + name.slice(1).toLowerCase();
  if (n.endsWith('/') || n.endsWith('-')) return n.slice(0, -1).trim() + '...';
  if (n.length >= 48) return n.slice(0, 45) + '...';
  return n;
};

// ── Admin-only: crisp 2-word labels for pie chart & legend ──────────────────
// Maps every known verbose category name (raw from DB, cleaned, or truncated)
// to a short, logically sound label (max 2 words).
const ADMIN_SHORT_MAP = {
  // exact long names returned by cleanCategoryName
  'repair, maintenance, and installation of plant/machinery': 'Plant Repair',
  'manpower outsourcing services - minimum wage - skilled':   'Skilled Manpower',
  'manpower outsourcing services - minimum wage - unskilled': 'Unskilled Manpower',
  // common short names that may come straight from DB
  'works':    'Works',
  'services': 'Services',
  'goods':    'Goods',
  'others':   'Others',
  'other':    'Others',
};

export const adminShortCategoryName = (name) => {
  if (!name) return 'Unknown';
  // First run through the general cleaner so we normalise truncated DB strings
  const cleaned = cleanCategoryName(name);
  const key = cleaned.toLowerCase().replace(/\.{3}$/, '').trim();

  // Direct lookup
  if (ADMIN_SHORT_MAP[key]) return ADMIN_SHORT_MAP[key];

  // Partial-match fallback for anything not in the map
  for (const [pattern, short] of Object.entries(ADMIN_SHORT_MAP)) {
    if (key.includes(pattern) || pattern.includes(key)) return short;
  }

  // Generic fallback: take first 2 words of the cleaned name
  const words = cleaned.replace(/\.\.\.$/, '').trim().split(/[\s,/-]+/).filter(Boolean);
  const twoWords = words.slice(0, 2).join(' ');
  return twoWords.charAt(0).toUpperCase() + twoWords.slice(1);
};

export const formatYAxisNumber = (num) => {
  if (num >= 1000000000) return (num / 1000000000).toFixed(1).replace(/\.0$/, '') + 'B';
  if (num >= 1000000) return (num / 1000000).toFixed(1).replace(/\.0$/, '') + 'M';
  if (num >= 1000) return (num / 1000).toFixed(1).replace(/\.0$/, '') + 'k';
  return num.toString();
};
